import React from "react";
import { CampaignSelection } from "../../organisms/campaign/CampaignSelection";
import { useCampaignSelection } from "./hook";

export const CampaignSelectionPage: React.FC = () => {
  const { activeCampaigns, handleCampaignClick, handleRegularOrderClick } =
    useCampaignSelection();
  return (
    <CampaignSelection
      campaigns={activeCampaigns}
      handleCampaignClick={handleCampaignClick}
      handleRegularOrderClick={handleRegularOrderClick}
    />
  );
};
